import React from 'react';
import styled from 'styled-components';
import { Product } from '@packages/common';

import { Flex, Icon, Text, themeGet, media } from '@packages/ui';

const MAX_STARS = new Array(5).fill(null);

const RatingContainer = styled(Flex)`
  order: 0;
  * {
    flex-grow: 0.007;
  }

  min-height: ${themeGet.fontSize(4)};
  margin-top: ${themeGet.space(1)};
  font-size: ${themeGet.fontSize(2)};
  ${media.to.md`
    display: none;
  `}
`;

const ZeroHeightText = styled(Text)`
  height: 0px;
  overflow-y: visible;
`;

const Stars: React.FC<{ score: number }> = ({ score }) => (
  <>
    {MAX_STARS.map((_, index) => {
      const cursor = index + 1;
      if (cursor <= score) {
        return <Icon name="starFull" size={14} key={index} />;
      }

      if (cursor > score && cursor - 1 < score) {
        return <Icon name="starHalf" size={14} key={index} />;
      }

      return <Icon name="starEmpty" size={14} key={index} />;
    })}
  </>
);

export interface ProductRatingProps {
  rating: Product['rating'];
}

export const ProductRating: React.FunctionComponent<ProductRatingProps> = ({ rating: { score, count } }) => (
  <RatingContainer>
    {!!score && <Stars score={score} />}
    {!!score && !!count && (
      <ZeroHeightText className="score" tag="span" color="black">
        ({count})
      </ZeroHeightText>
    )}
  </RatingContainer>
);

export const RatingPlaceholder = styled.div`
  display: none;
  ${media.from.xl`
    height: ${themeGet.space(4)};
    display: block;
  `}
`;
